import { Injectable } from '@angular/core';
import { LoginService } from './login.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WhatsappService {

  constructor(
    public ls: LoginService,
    public http: HttpClient
  ) { }

  async sendWhatsappGeneral(first: string,last: string,mobile: string,id:string,sendername:string,message: string) {
    try{
      return this.http.post('/api/whatsapp/sendMessage',{first,last,mobile,id,sendername,message}).toPromise();
    }catch(error){ 
      console.error('Error adding new message:', error); 
      throw error;
    }
  }
  getClinicMsgTemplate() {
    return this.http.get(`/api/whatsapp/getClinicMsgTemplate`).toPromise();
  };
  getAwaitingMsg() {
    return this.http.get(`/api/whatsapp/getMsgCount`).toPromise();
  }
}
